module.exports = __webpack_public_path__ + "static/media/header-city_elements.fe0c41f8.png";